/* eslint-disable @typescript-eslint/no-explicit-any */
import { Context, createContext } from 'react'
import { Index } from 'sdk'
import { Address } from 'viem'
import { Routers } from './phuture-provider'

export interface PhutureState {
  isConnected: boolean
  account: null //Account |
  indices: Map<Address | string, Index>
  routers: Routers | null
}

export const initialState: PhutureState = {
  isConnected: false,
  account: null,
  indices: new Map(),
  routers: null,
}

const contextKey = '__PHUTURE_CONTEXT__'

export function getPhutureContext(): Context<PhutureState & any> {
  let context = (createContext as any)[contextKey] as Context<PhutureState>
  if (!context) {
    Object.defineProperty(createContext, contextKey, {
      value: (context = createContext<PhutureState>(initialState)),
      enumerable: false,
      writable: false,
      configurable: true,
    })
    context.displayName = 'PhutureContext'
  }

  return context
}
